
window.useOpenCFTurnstileChecked = async () => {
  return await new Promise((resolve, reject) => {
    const req = {
      detail: {
        successCallback: (token) => {
          resolve(token)
        },
        errorCallback: (code) => {
          const err = {
            message: 'Turnstile recaptcha fail',
            code: code || 0
          }
          reject(err)
        }
      }
    }
    document.dispatchEvent(new CustomEvent('useOpenCFTurnstileChecked', req))
  })
}
/**
 * @description cf 验证
 * @param {*} el
 */

// 测试test
// const sitekey = '1x00000000000000000000AA' // 总是成功
// const sitekey = '2x00000000000000000000AB' // 总是阻塞
// const sitekey = '1x00000000000000000000BB' // 总是过去
// const sitekey = '2x00000000000000000000BB' // 总是阻塞
// const sitekey = '3x00000000000000000000FF' // 强制互动

window.useCFTurnstileChecked = (language, cb) => {
  return new Promise((resolve, reject) => {
    const render = function () {
      cb && cb()
      window.turnstile.render('#cf-turnstile', {
        sitekey: '0x4AAAAAAAQ0xNN_STcUteE5',
        theme: 'light',
        size: 'normal', // compact normal
        language: language === 'zh' ? 'zh-tw' : language || 'en',
        callback: function (token) {
          resolve(token)
        },
        'error-callback': function (err) {
          reject(err)
        }
      })
    }
    if (window.turnstile) {
      render()
    } else {
      window.onloadTurnstileCallback = render
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
      script.onerror = function (err) {
        reject(err)
      }
      document.body.appendChild(script)
    }
  })
}


/**
 * Drawer Submenu - 二级、三级菜单交互逻辑
 * 处理二级菜单的抽屉式导航和三级菜单的手风琴展开
 */

class DrawerSubmenu {
  constructor() {
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // 使用事件委托处理所有submenu相关的点击事件
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-submenu-toggle]');
      if (target) {
        this.handleSubmenuToggle(e, target);
      }
    });

    // 处理返回按钮
    document.addEventListener('click', (e) => {
      const backBtn = e.target.closest('.drawer-submenu__back-btn');
      if (backBtn) {
        this.handleBackButton(e);
      }
    });

    // 处理关闭按钮
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.drawer-submenu__close-btn');
      if (closeBtn) {
        this.handleCloseButton(e);
      }
    });
  }

  handleSubmenuToggle(e, target) {
    e.preventDefault();

    const subList = target.nextElementSibling;
    if (!subList || !subList.classList.contains('drawer-submenu__sub-list')) {
      return;
    }

    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapseSubmenu(target, subList);
    } else {
      this.expandSubmenu(target, subList);
    }
  }

  expandSubmenu(toggle, subList) {
    // 设置展开状态
    toggle.setAttribute('aria-expanded', 'true');
    subList.classList.add('expanded');
    
    // 计算实际高度并应用
    setTimeout(() => {
      const scrollHeight = subList.scrollHeight;
      subList.style.maxHeight = scrollHeight + 'px';
    }, 10);
  }

  collapseSubmenu(toggle, subList) {
    // 设置收起状态
    toggle.setAttribute('aria-expanded', 'false');
    subList.classList.remove('expanded');
    subList.style.maxHeight = '0px';
  }

  handleBackButton(e) {
    e.preventDefault();
    
    // 收起所有展开的三级菜单
    const currentSubmenu = e.target.closest('.drawer-submenu');
    if (currentSubmenu) {
      const expandedToggles = currentSubmenu.querySelectorAll('[aria-expanded="true"]');
      expandedToggles.forEach(toggle => {
        const subList = toggle.nextElementSibling;
        if (subList) {
          this.collapseSubmenu(toggle, subList);
        }
      });
    }

    // 隐藏当前二级菜单
    const submenuWrapper = e.target.closest('.drawer-menu__submenu-wrapper');
    if (submenuWrapper) {
      submenuWrapper.classList.remove('visible');
      submenuWrapper.setAttribute('aria-hidden', 'true');
    }

    // 触发drawer-menu的返回逻辑
    const backEvent = new CustomEvent('drawer-submenu:back');
    document.dispatchEvent(backEvent);
  }

  handleCloseButton(e) {
    e.preventDefault();
    
    // 触发drawer-menu的关闭逻辑
    const closeEvent = new CustomEvent('drawer-submenu:close');
    document.dispatchEvent(closeEvent);
  }

  // 初始化所有submenu的状态 - 默认展开三级菜单
  initializeState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      // 默认展开状态
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }

  // 重置所有submenu状态 - 默认展开三级菜单
  resetState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }
}

// 初始化DrawerSubmenu
const drawerSubmenu = new DrawerSubmenu();

// 暴露到全局作用域，供其他脚本使用
window.DrawerSubmenu = drawerSubmenu; 


/**
 * Global Country & Language Selector API
 *
 * Provides a simple interface to show/hide the country and language selector popup
 * from anywhere in your Shopify theme.
 *
 * @version 1.0.0
 */

(function (window) {
  'use strict'

  // Global API object
  const CountryLanguageSelector = {

    /**
     * Show the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onShown - Callback when popup is shown
     * @param {Function} options.onChanged - Callback when selection changes
     */
    show: function (options = {}) {
      const event = new CustomEvent('showCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      // Set up one-time listeners for callbacks
      if (options.onShown) {
        document.addEventListener('countryLanguageSelectorShown', options.onShown, { once: true })
      }
      if (options.onChanged) {
        document.addEventListener('countryLanguageChanged', options.onChanged, { once: true })
      }
    },

    /**
     * Hide the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onHidden - Callback when popup is hidden
     */
    hide: function (options = {}) {
      const event = new CustomEvent('hideCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      if (options.onHidden) {
        document.addEventListener('countryLanguageSelectorHidden', options.onHidden, { once: true })
      }
    },

    /**
     * Toggle the country/language selector popup
     * @param {Object} options - Optional configuration
     */
    toggle: function (options = {}) {
      const event = new CustomEvent('toggleCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)
    },


    /**
     * Check if popup is currently visible
     * @returns {boolean} True if popup is visible
     */
    isVisible: function () {
      const selector = document.getElementById('global-country-language-selector')
      return selector && selector.classList.contains('active')
    },

    /**
     * Initialize the selector (called automatically)
     * @private
     */
    init: function () {
      // Listen for DOM content loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setupAutoTriggers.bind(this))
      } else {
        this.setupAutoTriggers()
      }
    },

    /**
     * Setup automatic triggers based on data attributes
     * @private
     */
    setupAutoTriggers: function () {
      // Find elements with data-country-selector-trigger attribute
      const triggers = document.querySelectorAll('[data-country-selector-trigger]')

      triggers.forEach(trigger => {
        const action = trigger.getAttribute('data-country-selector-trigger') || 'toggle'

        trigger.addEventListener('click', (e) => {
          e.preventDefault()

          switch (action) {
          case 'show':
            this.show()
            break
          case 'hide':
            this.hide()
            break
          case 'toggle':
          default:
            this.toggle()
            break
          }
        })
      })

      // Auto-show functionality
      const autoShow = document.querySelector('[data-country-selector-auto-show]')
      if (autoShow && !localStorage.getItem('country-selector-auto-shown')) {
        const delay = parseInt(autoShow.getAttribute('data-country-selector-auto-show')) || 0

        setTimeout(() => {
          this.show()
          localStorage.setItem('country-selector-auto-shown', 'true')
        }, delay)
      }
    }
  }

  // Auto-initialize
  CountryLanguageSelector.init()

  // Expose to global scope
  window.CountryLanguageSelector = CountryLanguageSelector

  // Also expose as shorter alias
  window.CLS = CountryLanguageSelector
})(window)


